import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Pagination": Pagination, "@mui/material/PaginationItem": PaginationItem, "@mui/material/Stack": Stack, "@mui/icons-material/ArrowBack": ArrowBackIcon, "@mui/icons-material/ArrowForward": ArrowForwardIcon } } });
export default ClientProvider;
